import { createSelector } from 'reselect'
import { isEqual } from 'lodash'
import { RootStoreState } from '@src/models/app.types'

export const planStoreSelector = (state: RootStoreState) => state.plan

export const planCalendarDateSelector = createSelector(
  planStoreSelector,
  (planStore) => planStore.calendar,
  {
    memoizeOptions: {
      resultEqualityCheck: isEqual,
    },
  },
)
